// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p55c","toggle":"styles_toggle__15yMh","preview":"styles_preview__2ap5L"};